

















































































































































































































import { dateFormat } from "@/utils/timeFormat";
import { searchStudent } from "@/api/globalSearch";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import { approvalListApi, approvalListData } from "@/api/approve";
import { Vue, Component } from "vue-property-decorator";
import { UserModule } from "@/store/module/user";
import { PageModule } from "@/store/module/page";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  name: "approveLogMine",
  components: {
    commonStaffPullDown,
    commonDateRangeSelector,
  },
})
export default class extends Vue {
  searchInfo: any = {
    sort_field: "create_time",
    sort_type: "desc",
    handle_status: 1,
    create_time: [] as string[],
    approval_staff_id: "",
    initiate_staff_id: "",
    initiate_staff_list: [],
    copy_staff_id: "",
    copy_staff_list: [],
  };
  studentList: any[] = [];
  tableData: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  created() {
    this.handleSearchStudent("");
    const pageCache = PageModule.pageInfo.approveLogMine;
    if (pageCache.search_info) {
      this.searchInfo = pageCache.search_info;
    }
    if (pageCache.page) {
      this.page = pageCache.page;
    }
    if (pageCache.page_size) {
      this.pageSize = pageCache.page_size;
    }
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  handleSortChange(e: { order: string }) {
    if (e.order == "descending") {
      this.searchInfo.sort_type = "desc";
    } else if (e.order == "ascending") {
      this.searchInfo.sort_type = "asc";
    } else {
      this.searchInfo.sort_type = "";
    }
    this.handleSearch();
  }
  handleSearchStudent(v: any) {
    searchStudent({
      page: 1,
      page_size: 50,
      key_word: v || "",
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.studentList = res.data.list;
      }
    });
  }
  getList(params: { page: number; page_size: number }) {
    const option: approvalListData = {
      page: params.page,
      page_size: params.page_size,
      sort_field: "create_time",
      sort_type: this.searchInfo.sort_type,
      approval_staff_id: UserModule.userInfo.staff_id,
    };
    if (this.searchInfo.approval_no) {
      option.approval_no = this.searchInfo.approval_no;
    }
    if (this.searchInfo.student_id) {
      option.student_id = this.searchInfo.student_id;
    }
    if (this.searchInfo.type) {
      option.type = this.searchInfo.type;
    }
    if (this.searchInfo.initiate_staff_id) {
      option.initiate_staff_id = this.searchInfo.initiate_staff_id;
    }
    if (this.searchInfo.copy_staff_id) {
      option.copy_staff_id = this.searchInfo.copy_staff_id;
    }
    if (this.searchInfo.handle_status >= 0) {
      option.handle_status = this.searchInfo.handle_status;
    }
    if (
      this.searchInfo.create_time &&
      this.searchInfo.create_time.length === 2
    ) {
      option.start_date = this.searchInfo.create_time[0];
      option.end_date = this.searchInfo.create_time[1];
    }
    approvalListApi(option).then((res: any) => {
      this.page = res.data.page;
      this.total = res.data.total;
      res.data.list.map((item: any) => {
        item.create_time =
          item.create_time === 0
            ? "-"
            : dateFormat("YYYY-mm-dd HH:MM", item.create_time * 1000);
        item.approval_time =
          item.approval_time === 0
            ? "-"
            : dateFormat("YYYY-mm-dd HH:MM", item.approval_time * 1000);
        // 只有有转入学员并且两个学员不同,不是自己转自己
        if (
          item.transfer_join_student !== null &&
          item.student.student_id !== item.transfer_join_student.student_id
        ) {
          item.student_name = [
            item.student.name,
            item.transfer_join_student.name,
          ];
        } else {
          item.student_name = [item.student.name];
        }
      });
      this.tableData = res.data.list;
    });
  }
  handlePagerChange(e: number) {
    this.cachePageInfo();
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.cachePageInfo();
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
  cachePageInfo() {
    // 列表搜索数据
    PageModule.SET_PAGE_INFO({
      name: "approveLogMine",
      key: "search_info",
      value: { ...this.searchInfo },
    });
    // 页码等信息
    PageModule.SET_PAGE_INFO({
      name: "approveLogMine",
      key: "page",
      value: this.page,
    });
    PageModule.SET_PAGE_INFO({
      name: "approveLogMine",
      key: "page_size",
      value: this.pageSize,
    });
  }
  toRules() {
    this.cachePageInfo();
    this.$router.push({
      name: "approveRule",
    });
  }
  toOrderDetail(data: any) {
    this.cachePageInfo();
    this.$router.push({
      name: "approveLogDetail",
      query: {
        id: String(data.approval_id),
        from: "mine",
      },
    });
  }
}
